// extracted by mini-css-extract-plugin
export default {"Bottom":"style_Bottom__jO9ev","secondary":"style_secondary__Up0TE","card":"style_card__OUdom","button":"style_button__g3kna"};